module.exports = __webpack_public_path__ + "static/media/1009885.a8446428.jpg";